import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from '@tanstack/react-router';
import { CircleCheck, Eye, List, Plus } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { pcmpProjectDetailQueryOptions } from '../api/pcmpProjects.api';

/** Legacy CreatedSuccessfully, with a link to the new project. */
export function PcmpProjectCreatedPage() {
  const { projectId } = useParams({ from: '/_auth/pcmp/projects/$projectId/created' });
  const { data: project } = useQuery(pcmpProjectDetailQueryOptions(projectId));
  const name = project?.displayName ?? `Project ${projectId}`;

  return (
    <div className="mx-auto flex w-full max-w-lg flex-col items-center gap-5 rounded-xl border bg-card p-8 text-center shadow-sm">
      <span className="inline-flex size-12 items-center justify-center rounded-full bg-success text-success-foreground">
        <CircleCheck className="size-6" />
      </span>
      <div className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold">Project created</h1>
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">{name}</span> is set up with its book
          prices.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        <Link
          to="/pcmp/projects/$projectId"
          params={{ projectId }}
          className={cn(buttonVariants({ variant: 'default' }), 'gap-1.5')}
        >
          <Eye className="size-4" />
          View Project
        </Link>
        <Link
          to="/pcmp/projects/new"
          className={cn(buttonVariants({ variant: 'outline' }), 'gap-1.5')}
        >
          <Plus className="size-4" />
          Create Another
        </Link>
        <Link to="/pcmp/projects" className={cn(buttonVariants({ variant: 'outline' }), 'gap-1.5')}>
          <List className="size-4" />
          All Projects
        </Link>
      </div>
    </div>
  );
}
